import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalThemMoiChiNgoaiLe } from "./ModalThemMoiChiNgoaiLe";

export const BtnThemMoiChiNgoaiLe = ({}) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <button
        type="button"
        className="btn btn btn-border-new"
        onClick={handleShow}
      >
        <i className="mdi mdi-plus"></i> Tạo phiếu chi
      </button>
      {show && <ModalThemMoiChiNgoaiLe show={show} onHide={handleClose} />}
    </>
  );
};
